<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="title is-1">General:</div>
      <div v-if="questions && questions.length > 0">
        <question v-model="questions[0]" @change="change($event, '0')"></question>
        <br />
        <p>
          2. Please complete the following boxes for AWG assessment in its completion of the country scorecard (this may be a summary of the points given in responses above).
          Without limiting the foregoing, please indicate whether the applicable legal facts provide a high, medium, or low level of confidence as regards primacy and completeness (as defined in the above formula).
          This should be as concise (without over-simplification) and precise as possible. (500 word limit each)
        </p>
        <question v-model="questions[1]" @change="change($event, '1')"></question>
        <question v-model="questions[2]" @change="change($event, '2')"></question>
      </div>
      <br /><br />
      <div v-if="IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/3')">Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/b/0')">Next</b-button>
          </div>
        </div>
      </div>
      <div v-if="!IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button class="button is-primary" @click="save">Save</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: new Promise((resolve, reject) => { })
      }
    },
    props: {
      exporting: Boolean
    },
    computed: {
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      }
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/3');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/b/0');
        });
      },
      async save() {
        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.Comments);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.Comments);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      this.qpromise =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.Comments, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');
              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });
      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      var self = this;
      this.qpromise.then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }

</script>
